import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  CertificateOfInspectionId,
  Exit,
  GateAway,
  GrantPeriod,
  GrantedArea,
  LicensePlate,
  Team,
  VehicleName,
  VehicleRegistrationCertificateId,
} from "./_fields";

type BusinessVehicleCardProvideTemplate = {
  unit: string;
  nameVehical: string;
  licensePlate: string;
  vehicleRegistrationCertificateId: number;
  certificateOfInspectionId: number;
  grantPeriod: string;
  grantedArea: string;
  gateAway: string;
  exit: string;
};

export const businessVehicleCardProvideTemplate: TemplatesValue<BusinessVehicleCardProvideTemplate> =
  {
    fileName: "DanhSachThongTinPhuongTienCapThe",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      Team,
      VehicleName,
      LicensePlate,
      VehicleRegistrationCertificateId,
      CertificateOfInspectionId,
      GrantPeriod,
      GrantedArea,
      GateAway,
      Exit,
    ],
    fields: [
      "unit",
      "nameVehical",
      "licensePlate",
      "vehicleRegistrationCertificateId",
      "certificateOfInspectionId",
      "grantPeriod",
      "grantedArea",
      "gateAway",
      "exit",
    ],
  };
